import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useQuery } from '@apollo/client';

import { QUERY_LINK } from '../utils/queries';

import Button from 'react-bootstrap/Button';

import SignupModal from '../components/SignupModal';

import { useDocumentTitle } from '../components/useDocumentTitle';

import spinner from '../assets/spinner.gif';

import './AffiliatePage.css';


function storeName(url) {
  if (! url) {
    return '';
  }
  const re = /\/\/(.*?)([^/.]+\.[^/.]+)\//;
  const matches = url.match(re)
  return matches ? (matches[2] === 'amzn.to' ? 'Amazon' : matches[2]) : url;
}

function AffiliatePage() {
  const dispatch = useDispatch();

  const { id } = useParams();

  const [link, setLink] = useState(null);

  const { loading, error, data } = useQuery(QUERY_LINK, {variables: {id}});

  useDocumentTitle(link ? link.name : '');

  useEffect(() => {
    if (data) {
      setLink(data.link);
    }
  }, [data, loading, dispatch, id]);

  if (error) {
    return `Query error: ${error.message}`;
  }

  return (
    <>
      <nav className="breadcrumb"><Link to="/">Home</Link></nav>

      {link ? (
        <div className="affiliate-page">

          <h2>{link.name}</h2>

          {link.dealText ? <div className="deal">{link.dealText}</div> : null}

          <a href={link.url}>
            { link.image &&
              <img className="hero" src={`/image/${link.image}`} alt={link.name} />
            }
          </a>

          <p>{link.description}</p>

          <Button className="shop-link" href={link.url}>
            Buy on {storeName(link.url)}
          </Button>

        </div>
      ) : null}

      <SignupModal />

      {loading ? <img src={spinner} alt="loading" /> : null}
    </>
  );
}

export default AffiliatePage;
